<!--<div *ngFor="let columnDef of tableConfig">-->
<!--  {{columnDef.field}}-->
<!--</div>-->
<!--[globalFilterFields]="['code','description','country','lei']"-->
<div class="flexTableViewPort"
     (mouseenter)="focuseIn(-1, true)" (mouseout)="focusOut(true)"
     (mouseover)="focuseIn(-1, true)">
  <!--  (mouseenter)="focuseIn(-1, true)" (mouseout)="focusOut(true)"-->
  <!--  (mouseover)="focuseIn(-1, true)"-->
  <p-table #ccTable [class]="'crystal-table p-datatable-gridlines'+(totalRecords<=100?' no-paginator':'')"
           [value]="records" [loading]="loading"
           [dataKey]="fieldId" styleClass="p-datatable-sm"
           [paginator]="true" [totalRecords]="totalRecords"
           [rows]="100"
           [rowsPerPageOptions]="[100,200,500]" [showCurrentPageReport]="true"
           [globalFilterFields]="undefined"
           [lazy]="false" [lazyLoadOnInit]="false" (onLazyLoad)="loadRecords($event)"
           [defaultSortOrder]="defaultSortOrder" [sortOrder]="defaultSortOrder"
           [sortField]="defaultSortField||defaultSortField===''?defaultSortField:fieldName"
           [virtualScroll]="false" [scrollable]="true" [scrollHeight]="scrollHeight"
           virtualScrollItemSize="19" responsiveLayout="scroll"
           paginatorDropdownAppendTo="body"
           (mousedown)="mouseDown=true;" (mouseup)="mouseDown=false;"
           [currentPageReportTemplate]="''"
           (onFilter)="onFilterChange()" (onSort)="onSortChange()"
           [resizableColumns]="true" columnResizeMode="expand"
           (focusin)="focuseIn(-1)" (focusout)="focusOut()"
           (mouseenter)="focuseIn(-1, true)" (mouseout)="focusOut(true)"
           editMode="row"
  >
    <!--    (mouseenter)="focuseIn(-1,true)" (mouseout)="focusOut(true)"-->
    <!--    currentPageReportTemplate="{totalRecords} {{'page.'+this.transPartKey+'.footer_count' | translate}}"-->
    <!--    (onRowReorder)="rowOrderChanged.emit($event)"-->
    <ng-template pTemplate="caption">
      <p-toolbar class="table-toolbar">
        <div class="p-toolbar-group-left">
          <span
            class="table-toolbar-title">{{ totalRecords + ' ' + ('page.' + this.transPartKey + '.title' | translate) }}</span>
          <ng-content select="[toolbar-left]"></ng-content>
          <span class="table-toolbar-buttons">
            <ng-template ngFor let-buttonConf [ngForOf]="headerButtonConfig" let-confIndex="index">
              <ng-container>
                  <i *ngIf="buttonConf.separator" class="toolbar-separator fa fa-diamond">
                  </i>
                  <button *ngIf="!buttonConf.separator&&!buttonConf.items" pButton
                          type="button" [disabled]="!tableValueMap['bttHeaderEnabled-'+confIndex]"
                          (click)="buttonConf.command(selectedRecords)" [icon]="buttonConf.icon"
                          [class]="'p-button-text p-button-sm '+buttonConf.class" [pTooltip]="buttonConf.tooltip"
                          [label]="buttonConf.label"
                  ></button>
                  <span *ngIf="buttonConf.items">
                    <p-menu #menu [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [popup]="true"
                            [model]="buttonConf.items"></p-menu>
                    <button type="button" pButton [disabled]="!tableValueMap['bttHeaderEnabled-'+confIndex]"
                            (click)="menu.toggle($event)" [icon]="buttonConf.icon"
                            [class]="'p-button-text p-button-sm '+buttonConf.class" [pTooltip]="buttonConf.tooltip"
                            [label]="buttonConf.label"></button>
                  </span>
              </ng-container>
            </ng-template>
          </span>
        </div>
        <div class="p-toolbar-group-center">
          <ng-content select="[toolbar-center]"></ng-content>
        </div>
        <div class="p-toolbar-group-right">
          <ng-content select="[toolbar-right]"></ng-content>
<!--          <span *ngIf="!reorderableRows" class="p-input-icon-left p-ml-auto">-->
<!--              <i class="pi pi-search"></i>-->
<!--              <input pInputText type="text" class="p-inputtext-sm p-menu-search-input" [(ngModel)]='globalFilterValue'-->
<!--                     (input)="ccTable.filterGlobal(globalFilterValue, 'contains');"-->
<!--                     placeholder="{{'common.table.filter_global' | translate}}"/>-->
<!--          </span>-->
          <button *ngIf="!reorderableRows" pButton class="p-button-text p-button-sm header-button clear-filter-button"
                  icon="pi pi-filter-slash"
                  (click)="clearFilter()" pTooltip="{{'common.table.clear_filters' | translate}}"
                  tooltipPosition="left"
                  [disabled]="!tableValueMap['hasFilter']"></button>
          <button *ngIf="!reorderableRows" pButton class="p-button-text p-button-sm header-button clear-sort-button"
                  icon="pi pi-sort-alt-slash"
                  (click)="clearSort()" pTooltip="{{'common.table.clear_sort' | translate}}"
                  [disabled]="!tableValueMap['hasSort']"></button>
        </div>
      </p-toolbar>
    </ng-template>
    <!--    <ng-template pTemplate="colgroup">-->
    <!--      <colgroup>-->
    <!--        <col *ngFor="let columnDef of tableConfig" [style]="'width:'+(columnDef.width?columnDef.width+'px':'100%')">-->
    <!--      </colgroup>-->
    <!--    </ng-template>-->
    <ng-template pTemplate="header">
      <!--      [style]="columnDef.width+'px'"-->
      <!--      pResizableColumn-->
      <tr>
        <th *ngIf="reorderableRows" class="w-20px"></th>
<!--        <th style="width:20px"></th>-->
        <th *ngFor="let columnDef of tableConfig"
            [pResizableColumn]="!reorderableRows&&!columnDef.notResizable&&columnDef.type!='BUTTON'?columnDef.field:''"
            [pSortableColumn]="!reorderableRows&&!columnDef.notSortable&&columnDef.type!='BUTTON'?columnDef.field:''"
            [style.width]="!columnDef.hidden && columnDef.width ? columnDef.width+'px' : null"
            [style.text-align]="!columnDef.hidden ? columnDef.align : null"
            [style.display]="columnDef.hidden ? 'none' : null"
            [hidden]="columnDef.hidden">
          <div *ngIf="columnDef.field" class="flex align-items-center">
            {{ columnDef.label ? columnDef.label : 'page.' + this.transPartKey + '.table.' + columnDef.field | translate }}
            <p-columnFilter *ngIf="!reorderableRows&&!columnDef.notFilterable" #filterField
                            [type]="columnDef.filterConfig?columnDef.filterConfig.type:'text'"
                            [field]="columnDef.field" display="menu"
                            [matchMode]="columnDef.filterConfig?columnDef.filterConfig.matchMode:'contains'"
                            [showMatchModes]="complexFilterMode||columnDef.filterConfig&&columnDef.filterConfig.type==='date'"
                            [showOperator]="complexFilterMode"
                            [showAddButton]="complexFilterMode||columnDef.filterConfig&&columnDef.filterConfig.type==='date'"
                            [showApplyButton]="!columnDef.filterConfig||!columnDef.filterConfig.values"
                            [showClearButton]="true" [hideOnClear]="true"
                            [maxFractionDigits]="columnDef.filterConfig&&columnDef.filterConfig.type==='numeric'?5:undefined"
            >
              <ng-template *ngIf="columnDef.filterConfig&&columnDef.filterConfig.values" pTemplate="filter" let-value
                           let-filter="filterCallback">
                <p-dropdown *ngIf="columnDef.filterConfig.values&&columnDef.filterConfig.values.length===2"
                            [ngModel]="value" [options]="columnDef.filterConfig.values"
                            placeholder="Any" (onChange)="filter($event.value); filterField.hide();">
                  <ng-template let-option pTemplate="item">
                    <span [class]="'option-' + option">{{ option }}</span>
                  </ng-template>
                </p-dropdown>
                <p-multiSelect *ngIf="columnDef.filterConfig.values&&columnDef.filterConfig.values.length>2"
                               [ngModel]="value"
                               [options]="columnDef.filterConfig.values" placeholder="Any"
                               (onChange)="filter($event.value); filterField.hide();">
                  <ng-template let-option pTemplate="item">
                    <div class="p-multiselect-option">
                      {{ option }}
                    </div>
                  </ng-template>
                </p-multiSelect>
              </ng-template>
            </p-columnFilter>
            <p-sortIcon *ngIf="!reorderableRows&&!columnDef.notSortable&&columnDef.type!='BUTTON'"
                        [field]="columnDef.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record let-rowIndex="rowIndex" let-editing="editing">
      <tr [pContextMenuRow]="record" [pEditableRow]="record"
          [ngClass]="(record.selected?'p-highlight ':'')+(fieldEnabled && record[fieldEnabled]?'record-enabled':'record-disabled') + ' stripe_0'"
          [pReorderableRow]="rowIndex" (dragend)="rowOrderChanged.emit(records)"
          (mousedown)="onRowMouseDown(record, rowIndex, $event)"
          (mouseup)="onRowMouseUp(record, rowIndex, $event)"
          [id]="record[fieldId]"
          (focusin)="focuseIn(rowIndex)" (focusout)="focusOut()"
          (mouseenter)="focuseIn(rowIndex,true)" (mouseout)="focusOut(true)">

        <td *ngIf="reorderableRows" class="w-20px flex-basis-20px">
          <span class="fa-solid fa-grip-vertical" pReorderableRowHandle></span>
        </td>
<!--        <td style="width: 40px;flex-basis: 40px; max-width: 40px">-->
<!--          <div class="flex edit-btts">-->
<!--            <button-->
<!--              *ngIf="!editing"-->
<!--              pButton-->
<!--              pRipple-->
<!--              type="button"-->
<!--              pInitEditableRow-->
<!--              icon="pi pi-pencil"-->
<!--              (click)="onRowEditInit(record)"-->
<!--              class="p-button-rounded p-button-text">-->
<!--            </button>-->
<!--            <button-->
<!--              *ngIf="editing"-->
<!--              pButton-->
<!--              pRipple-->
<!--              type="button"-->
<!--              pSaveEditableRow-->
<!--              icon="pi pi-check"-->
<!--              (click)="onRowEditSave(record)"-->
<!--              class="p-button-rounded p-button-text p-button-success mr-2">-->
<!--            </button>-->
<!--            <button-->
<!--              *ngIf="editing"-->
<!--              pButton pRipple-->
<!--              type="button"-->
<!--              pCancelEditableRow-->
<!--              icon="pi pi-times"-->
<!--              (click)="onRowEditCancel(record, rowIndex)"-->
<!--              class="p-button-rounded p-button-text p-button-danger">-->
<!--            </button>-->
<!--          </div>-->
<!--        </td>-->
        <ng-template ngFor let-columnDef [ngForOf]="tableConfig" let-columnIndex="index">
          <td
            [style.min-width]="!columnDef.hidden && columnDef.width ? columnDef.width+'px' : null"
            [style.text-align]="!columnDef.hidden ? columnDef.align : null"
            [style.padding-right]="!columnDef.hidden && !reorderableRows && !columnDef.notFilterable && columnDef.filterConfig ? '20px' : null"
            [style.flex-basis]="!columnDef.hidden && columnDef.width ? columnDef.width+'px' : null"
            [style.display]="columnDef.hidden ? 'none' : null"
            [hidden]="columnDef.hidden"
            [class]="(tableValueMap['class-' + columnIndex + '_' + rowIndex]?tableValueMap['class-' + columnIndex + '_' + rowIndex]:'')
                    +(columnDef.type==='BUTTON'?' button-table':'')"
            (dblclick)="onRowDblClick_(record)" (auxclick)="onRowRightClick_(record)">
<!--            (click)="selectCell($event,columnDef,  record[columnDef.field])"-->

            <app-cc-field-dispatcher *ngIf="tableValueMap['editable-'+columnIndex + '_' + rowIndex]" #ccSubForm [loading]="loading"
                                     [transPartKey]="transPartKey"
                                     [formRecord]="record" [fieldConfig]="columnDef.formFieldConfig"
                                     (formRecordChange)="recordChanged(record)"></app-cc-field-dispatcher>

            <app-cc-cell-dispatcher *ngIf="!tableValueMap['editable-'+columnIndex + '_' + rowIndex]" [record]="record" [columnDef]="columnDef" [columnIndex]="columnIndex"
                                    [rowIndex]="rowIndex" [tableValueMap]="tableValueMap" ></app-cc-cell-dispatcher>

          </td>
        </ng-template>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <span *ngIf="selectionMode!='none'"
        class="footer-selected-count">{{selectedRecords && selectedRecords.length > 0 ? (selectedRecords.length + ' ' + ('common.selected' | translate)) : ''}}</span>
      <ng-content select="[paginatorleft-content]"></ng-content>
      <ng-template ngFor let-buttonConf [ngForOf]="footerButtonConfig" let-confIndex="index">
      <span>
        <span *ngIf="buttonConf.separator" class="toolbar-separator"></span>
        <button *ngIf="!buttonConf.separator" pButton
                type="button" [disabled]="!tableValueMap['bttFooterEnabled-'+confIndex]"
                (click)="buttonConf.command(selectedRecords)" [icon]="buttonConf.icon"
                [class]="'p-button-text p-button-sm '+buttonConf.class" [pTooltip]="buttonConf.tooltip"></button>
      </span>
      </ng-template>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <ng-content select="[paginatorright-content]"></ng-content>
      <button pButton class="p-button-text p-button-sm" icon="fa fa-file-excel" tooltipPosition="top"
              [class]="'footer-button p-button-text p-button-sm '"
              (click)="exportRecords('xlsx')" pTooltip="{{'common.table.export_xls' | translate}}"></button>
      <button pButton class="p-button-text p-button-sm" icon="fa fa-file-csv" tooltipPosition="top"
              [class]="'footer-button p-button-text p-button-sm '"
              (click)="exportRecords('csv')" pTooltip="{{'common.table.export_csv' | translate}}"></button>
      <!--      <button pButton class="p-button-text p-button-sm" icon="fa fa-file-pdf"-->
      <!--              (click)="saveAsPDFFile()" pTooltip="{{'common.table.export_pdf' | translate}}"></button>-->
    </ng-template>
  </p-table>
</div>
